import { render } from "./EmailSetting.vue?vue&type=template&id=2d2f60b6&scoped=true"
import script from "./EmailSetting.vue?vue&type=script&lang=js"
export * from "./EmailSetting.vue?vue&type=script&lang=js"

import "./EmailSetting.vue?vue&type=style&index=0&id=2d2f60b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2f60b6"]])

export default __exports__